var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 76.175V25V25.5438",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9085 50.1085H39.8975L38.5359 49.9501C38.158 49.9061 37.7904 49.7981 37.4487 49.6307V49.6307C37.1041 49.4619 36.7883 49.2324 36.5205 48.9576V48.9576C36.0225 48.4468 35.6917 47.7876 35.5841 47.0824L35.5209 46.6677C35.4849 46.4319 35.4668 46.1937 35.4668 45.9551V37.4585",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6632 40.2753C90.6055 34.8236 90.3432 34.0752 89.2739 31.9768C88.0491 29.5725 86.0941 27.6177 83.69 26.3927C80.9568 25 77.3784 25 70.2222 25H34.4444C27.2882 25 23.7101 25 20.9768 26.3927C18.5725 27.6177 16.6177 29.5725 15.3927 31.9768C14 34.7101 14 38.2882 14 45.4444V55.6667C14 62.8229 14 66.4013 15.3927 69.1344C16.6177 71.5386 18.5725 73.4936 20.9768 74.7183C23.7101 76.1111 27.2882 76.1111 34.4444 76.1111H70.2222C77.3784 76.1111 80.9568 76.1111 83.69 74.7183C86.0941 73.4936 88.0491 71.5386 89.2739 69.1344C90.4323 66.8611 90.6254 65.2506 90.6579 59.9211",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogo);
export default __webpack_public_path__ + "static/media/applogo.c359b60eec2b3ad35b4169047b51b7f2.svg";
export { ForwardRef as ReactComponent };